// CommonJS on purpose: consumed by both the CRA bundle (src/components/PageTitle.js)
// and the plain Node post-build script (scripts/generate-route-html.js).
const DEFAULT_TITLE = 'inLoop';
const DEFAULT_DESCRIPTION = 'inLoop - Build engaging customer loyalty programs';

const ROUTE_META = {
  '/': {
    title: 'inLoop | AI-Powered Behavioral Loyalty SaaS',
    description:
      'AI-powered behavioral loyalty SaaS. Turn customer behavior into measurable business growth with inLoop.',
  },
  '/product-features': {
    title: 'Campaign Engine & Loyalty Platform Features | inLoop',
    description:
      "Explore inLoop's campaign engine, loyalty platform features, and no-code campaign management.",
  },
  '/further-capabilities': {
    title: 'Code Generation, Gamification & Notification Engines | inLoop',
    description:
      'Code generation, gamification, and notification engines that extend your loyalty programs.',
  },
  '/references': {
    title: 'Customer Case Studies | inLoop',
    description:
      'Customer case studies and success stories from brands using inLoop.',
  },
  '/blog': {
    title: 'Loyalty Insights & Blog | inLoop',
    description:
      'Insights on behavioral loyalty, B2B2C programs, and AI-driven campaign optimization.',
  },
  '/faq': {
    title: 'Loyalty Platform FAQ | inLoop',
    description:
      'Answers to common questions about the inLoop loyalty platform - integrations, security, pricing, and support.',
  },
  '/about-us': {
    title: 'About inLoop — Behavioral Loyalty SaaS',
    description:
      'inLoop is an adesso Group company building AI-powered behavioral loyalty software.',
  },
  '/contact-us': {
    title: 'Contact inLoop — Book a Demo',
    description:
      'Get in touch with inLoop to book a demo of the behavioral loyalty platform.',
  },
  '/pricing': {
    title: 'Loyalty Program Pricing & Plans | inLoop',
    description:
      'Loyalty program pricing and plans - Starter, Plus, Premium, and Enterprise.',
  },
  '/ai-intelligence': {
    title: 'AI Intelligence — AI-Powered Loyalty Segmentation | inLoop',
    description:
      'Natural language segmentation, real-time audience sizing, and AI-generated campaign scenarios - without moving data outside your warehouse.',
  },
  '/unsubscribe': {
    title: 'Unsubscribe | inLoop',
    description: 'Unsubscribe from inLoop Blog emails.',
    robots: 'noindex',
  },
  '/subscribe/confirm': {
    title: 'Confirm Subscription | inLoop',
    description: 'Confirm your subscription to inLoop Blog emails.',
    robots: 'noindex',
  },
};

module.exports = { DEFAULT_TITLE, DEFAULT_DESCRIPTION, ROUTE_META };
